const { getElement } = window.BAO.Utils

let dropdownLoaded = false

const TRIGGER_EXPANDED_SELECTOR =
  '[data-header-dropdown-el="trigger"], [data-header-dropdown-el="menu-dropdown-toggle"]'
const EXPANDED_STATE_SELECTOR =
  '[aria-expanded="true"], [data-expanded="true"]'

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=dropdown`,
      )
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        const hdBannerDropdown = document.querySelector(
          '.hd-Banner_Dropdown.hd-Banner_Dropdown-seo',
        )

        if (hdBannerDropdown) {
          hdBannerDropdown.classList.remove('visibility-hidden')
        }
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (
      document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      document.addEventListener(
        'click',
        this.handleToggleButtonClick.bind(this),
      )
    }

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    document.addEventListener('pointermove', this.onPointerMove)
    document.addEventListener('mouseleave', this.onMouseLeave)

    document.addEventListener('focusin', this.handleFocusIn.bind(this))

    document.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (!this.els?.['menu-dropdown-toggle']?.exists) return

    const menuToggleEl = event.target.closest(
      this.els?.['menu-dropdown-toggle'].selector,
    )

    if (!menuToggleEl) {
      return
    }

    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })

    if (!menuDropdownEl) return

    const isExpanded = menuDropdownEl.getAttribute('data-expanded') === 'true'

    if (isExpanded) {
      this.setItemExpanded(parentItemEl, false)

      this.setBackdrop(0)
    } else {
      this.closeDropdowns()
      this.setItemExpanded(parentItemEl, true)

      document.dispatchEvent(new CustomEvent('dropdown:open'))
      this.setBackdrop(menuDropdownEl.offsetHeight)
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest(EXPANDED_STATE_SELECTOR)
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('data-active')
      })
    }

    if (this.els?.item?.exists) {
      this.els.item.elements.forEach((itemEl) => {
        this.setItemExpanded(itemEl, false)
      })
    }

    if (this.els?.['menu-dropdown']?.exists) {
      this.els?.['menu-dropdown']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('data-expanded')
      })
    }

    this.setBackdrop(0)
  }

  onPointerMove (event) {
    const activeTrigger = event.target.closest(
      '[data-header-dropdown-el="trigger"]',
    )
    const activeDropdown = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown"]',
    )

    if (!activeTrigger && !activeDropdown) {
      this.closeDropdowns()
      return
    }

    if (activeTrigger) {
      const matchedDropdown = this.querySelector(
        `[data-header-dropdown-el="menu-dropdown"]#${activeTrigger.dataset.id}`,
      )

      const parentItemEl = activeTrigger.closest(this.els?.item?.selector)

      if (matchedDropdown && parentItemEl) {
        this.closeDropdowns()
        this.setItemExpanded(parentItemEl, true)

        this.setBackdrop(matchedDropdown.offsetHeight)
      } else {
        this.closeDropdowns()
      }
    }
  }

  onMouseLeave () {
    this.closeDropdowns()
  }

  setBackdrop (heightValue) {
    const backdropEl = this.querySelector(
      `[data-header-dropdown-el="backdrop"]`,
    )

    backdropEl.style.setProperty(
      '--Height',
      heightValue === 0 ? 0 : `calc(100% + ${heightValue}px)`,
    )
    backdropEl.setAttribute('aria-hidden', heightValue === 0)
  }

  setItemExpanded (itemEl, isExpanded) {
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: itemEl,
    })

    if (menuDropdownEl) {
      if (isExpanded) {
        menuDropdownEl.setAttribute('data-expanded', 'true')
      } else {
        menuDropdownEl.removeAttribute('data-expanded')
      }
    }

    itemEl.querySelectorAll(TRIGGER_EXPANDED_SELECTOR).forEach((controlEl) => {
      controlEl.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
    })

    const menuToggleEl = getElement(
      this.els?.['menu-dropdown-toggle']?.selector,
      {
        context: itemEl,
      },
    )

    if (menuToggleEl) {
      if (isExpanded) {
        menuToggleEl.setAttribute('data-active', 'true')
      } else {
        menuToggleEl.removeAttribute('data-active')
      }
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
